import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { SnackbarProvider } from "notistack";

import "./index.css";

import "react-loading-skeleton/dist/skeleton.css";
import { App } from "./App";
import { store } from "./store/rootStore";
import { reportWebVitals } from "./reportWebVitals";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://23ce2862b27c3a2e48d5dfe7c735c070@o421465.ingest.us.sentry.io/4508207452979200",
  integrations: [],
});

ReactDOM.render(
  <React.StrictMode>
    <SnackbarProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
